/* tslint:disable */

/**
 */
export class EconomicResult {
    month?: number;
    id?: number;
    tc?: number;
    vc?: number;
    kgProduct?: number;
    product?: number;
    day?: number;
    week?: number;
    equipName?: string;
    year?: number;
    eqptPerm?: number;
    eqptCold?: number;
    lineCold?: number;
    linePerm?: number;
    tank?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/economic-result.ts